
const api={
    api: 'https://xingluoapi.linkstars.com/',
    //下载访问
    api2: 'http://dsrwtest.zhengdianhaohuo.com/kpxd/exportOrder',
    api_down: process.env.NODE_ENV === 'production' ? "http://dsrw.zhengdianhaohuo.com" : "http://dsrwtest.zhengdianhaohuo.com",

};
export default api;
